<div class="login-page">

  <app-loading-bar [active]="isLoading()" [progress]="loginProgress()" />

  <div class="app-header">
    <img src="/icons/logo-claro.svg" alt="Claro" class="logo" />
  </div>

  <div class="login-container">

    <div class="login-card">
      <h2 class="form-title">Inicia sesión</h2>
      
      <div class="tab-group">
        <button 
          type="button"
          class="tab" 
          [class.active]="loginMode() === 'AD'"
          (click)="selectMode('AD')">
          Usuario de RED
        </button>
        <button 
          type="button"
          class="tab" 
          [class.active]="loginMode() === 'MASTER_CODE'"
          (click)="selectMode('MASTER_CODE')">
          Código Maestro
        </button>
      </div>

      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="username">{{ usernameLabel() }}</label>
          <input
            id="username"
            type="text"
            [placeholder]="usernamePlaceholder()"
            [(ngModel)]="username"
            name="username"
            [class.error]="errorMessage()"
            [attr.aria-describedby]="errorMessage() ? 'login-error' : null"
            autocomplete="username"
            required
          />
        </div>

        <div class="form-group">
          <label for="password">Contraseña</label>
          <div class="password-input-wrapper">
            <input
              id="password"
              [type]="showPassword() ? 'text' : 'password'"
              placeholder="Ingresa tu contraseña"
              [(ngModel)]="password"
              name="password"
              [class.error]="errorMessage()"
              [attr.aria-describedby]="errorMessage() ? 'login-error' : null"
              autocomplete="current-password"
              required
            />
            <button 
              type="button" 
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
                @if (!showPassword()) {
                  <line x1="1" y1="1" x2="23" y2="23"/>
                }
              </svg>
            </button>
          </div>
        </div>

        <div class="forgot-password">
          <a href="javascript:void(0)" class="btn-tertiary" (click)="goToForgotPassword()">
            ¿Olvidaste tu contraseña?
          </a>
        </div>

        @if (errorMessage()) {
          <div id="login-error" class="error-message" role="alert">
            {{ errorMessage() }}
          </div>
        }

        @if (showCaptchaV2()) {
          <div class="captcha-v2">
            <div #recaptchaV2Container></div>
          </div>
        }

        @if (successMessage()) {
          <div class="success-message" role="status">
            {{ successMessage() }}
          </div>
        }

        <button 
          type="submit" 
          class="btn btn-primary"
          [disabled]="isLoading()">
          {{ isLoading() ? 'Ingresando...' : 'Ingresar' }}
        </button>
      </form>

    </div>
  </div>

  <app-footer></app-footer>

  <app-active-session-modal
    [isVisible]="showActiveSessionModal()"
    [sessionInfo]="sessionInfo()"
    (success)="onSuccessInvalidation()"
    (cancel)="onCancelSession()">
  </app-active-session-modal>

  <app-password-expired-modal
    [isVisible]="showPasswordExpirationModal()"
    [daysRemaining]="passwordDaysRemaining()"
    (changePassword)="onChangeExpiredPassword()"
    (skip)="onSkipPasswordChange()">
  </app-password-expired-modal>

</div>
